import { css } from '@emotion/css'
import { spacing, borderRadius, zIndex, fontFamily } from '../../styles'
import { colors } from '../../themes'
import { hexToRgba } from '../../themes/helpers'

const styles = {
  wrapper: css({
    position: 'relative',
    fontFamily: fontFamily.body,
  }),

  label: css({
    display: 'flex',
    alignItems: 'center',
    color: colors.jumbo,
    cursor: 'pointer',
    userSelect: 'none',
    whiteSpace: 'nowrap',

    '&[disabled]': {
      pointerEvents: 'none',
      cursor: 'default',
    },

    '&:hover': {
      textDecoration: 'underline',
    },

    '&:focus': {
      outline: 'none',
      textDecoration: 'underline',
    },
  }),

  labelPlaceholder: css({
    color: colors.grayChateau,
  }),

  labelOpen: css({
    position: 'relative',
    zIndex: zIndex.level6,
  }),

  arrow: css({
    display: 'flex',
    aligItems: 'center',
    justifyContent: 'center',
    marginLeft: spacing.small,
  }),

  body: css({
    position: 'absolute',
    top: '100%',
    right: -24,
    zIndex: zIndex.level6,
    listStyle: 'none',
    padding: 0,
    margin: 0,
    marginTop: spacing.extraSmall,
    backgroundColor: colors.white,
    border: `1px solid ${colors.mystic}`,
    borderRadius: borderRadius.default,
    boxShadow: `0 2px 4px ${hexToRgba(colors.scorpion, 0.1)}`,

    '& > * + *': {
      borderTop: `1px solid ${colors.mystic}`,
    },
  }),

  overlay: css({
    position: 'fixed',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: zIndex.level5,
  }),
}

export default styles
